<template>
  <footer>
    <div class="flex-row">
      <template
        v-for="(link, index) in linkList"
        :key="link.id"
      >
        <a
          :class="link.elClass"
          :href="link.href"
          target="_blank"
        >{{ link.text }}</a>

        <div v-if="index < (linkList.length - 1)" class="vert_sep"></div>
      </template>
    </div>
  </footer>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import useAppResourcesHook from '@/hooks/useAppResources.js';

const { proxy } = getCurrentInstance();

const { appLegalResources } = useAppResourcesHook();

const linkList = computed(() => [
  {
    id: 'terms',
    elClass: 'terms',
    href: appLegalResources.value.terms,
    text: proxy.$_translate('footer_text_terms_and_conditions'),
  },
  {
    id: 'privacy',
    elClass: 'privacy',
    href: appLegalResources.value.privacy,
    text: proxy.$_translate('footer_text_privacy_and_policy'),
  },
]);
</script>
